import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";

type Experience = {
  reducedMotion: boolean;
  paused: boolean;
  staticMode: boolean;
  toggleMotion: () => void;
  toggleStatic: () => void;
};
const Context = createContext<Experience>({
  reducedMotion: false,
  paused: false,
  staticMode: false,
  toggleMotion: () => {},
  toggleStatic: () => {},
});
export function ExperienceProvider({ children }: { children: ReactNode }) {
  const [reducedMotion, setReduced] = useState(false);
  const [paused, setPaused] = useState(false);
  const [staticMode, setStatic] = useState(false);
  useEffect(() => {
    const preference = matchMedia("(prefers-reduced-motion: reduce)");
    const sync = () => setReduced(preference.matches);
    sync();
    preference.addEventListener("change", sync);
    const connection = (
      navigator as Navigator & { connection?: { saveData?: boolean } }
    ).connection;
    if (connection?.saveData) setStatic(true);
    return () => preference.removeEventListener("change", sync);
  }, []);
  useEffect(() => {
    document.documentElement.dataset.motion =
      reducedMotion || paused ? "off" : "on";
  }, [reducedMotion, paused]);
  return (
    <Context.Provider
      value={{
        reducedMotion,
        paused,
        staticMode,
        toggleMotion: () => setPaused((v) => !v),
        toggleStatic: () => setStatic((v) => !v),
      }}
    >
      {children}
    </Context.Provider>
  );
}
export const useExperience = () => useContext(Context);
